/**
 * Utility function to create a delay promise
 *
 * @param ms - The number of milliseconds to delay
 * @returns A promise that resolves after the specified delay
 *
 * @example
 * // Wait for 2 seconds
 * await delay(2000);
 */
export const delay = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const utils = {
  delay,
};

export default utils;
